import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import LoadingSpinner from '../components/ui/LoadingSpinner';

const ProtectedRoute = () => {
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.auth.loading);

  if (!user) return <Navigate to="/login" replace />;

  if (loading) {
    return <LoadingSpinner message="Loading..." fullHeight />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
